<template>
	<div id="editor">
		<div v-if="working" class="d-flex justify-content-center align-items-center" style="min-height:300px">
			<spinner size="huge" message="Updating..."></spinner>
		</div>
		<div v-if="!working">
			<form v-on:submit.prevent="transmitForm">
				<div class="container">
					<div class="head row">
						<div class="col col-sm-3" style="text-align:left">
							<i class="pseudobutton mdi mdi-arrow-right-bold-circle mdi-24px" @click="$emit('closeEditor')"><span style="">Back</span></i>
						</div>
						<div class="col col-sm-9">
							<h3>Add Domains to Delete</h3>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<label  class="col-sm-3 col-form-label" for="s_name">Name</label>
							<textarea v-model="domainlist" style="width:100%;height:60vh"></textarea>
						</div>
					</div>
					<div class="row">
						<div class="col form-group" style="text-align:center">
							<button class="btn btn-success" type="submit">Add</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import Spinner from 'vue-simple-spinner'

export default {

	components: {
		Spinner
	},
	props: ['site', 'servers', 'working'],

	data() {
		return {
			renewclass: '',
			domainlist: ''
		}
	},
	created: function() {
	},
  methods: {
		transmitForm() {
			var fields = [ 'DNS_NAME', 'DNS_ADMIN_URL', 'DNS_ADMIN_USER', 'DNS_ADMIN_PWD']
			let transfer = {}
			for(var i = 0;i < fields.length;i++) {
				transfer[fields[i]] = this.site[fields[i]]
			}
			this.$emit('insertItem', transfer)
		},
  }
}
</script>
